import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const BackMenuButtonDefaultProps = {
  ...ClassNameDefaultProps,
  label: '',
  onClick: () => null,
};

export const BackMenuButtonPropTypes = {
  ...ClassNamePropTypes,
  label: PropTypes.string,
  onClick: PropTypes.func,
};
